import {combineReducers} from 'redux';
import winners from './uberEats/winners';
import game from './uberEats/game';
import stats from './uberEats/stats';
import gameWeek from './uberEats/gameWeek';
import results from './uberEats/results';
import secondaryWinners from './uberEats/secondaryWinners';
import config from './uberEats/config';

export default combineReducers({
  winners,
  game,
  stats,
  gameWeek,
  results,
  secondaryWinners,
  config,
});



// WEBPACK FOOTER //
// ./src/reducers/app/uberEats.js